module.exports = "\n<div>\n    <img class=\"logo centered\" [src]=\"logo | safeUrl\">\n</div>\n<h1>Page Not Found</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/not-found/not-found.component.html
// module id = ./src/app/core/components/not-found/not-found.component.html
// module chunks = main